import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from 'common/components/EmptyState';
import { ERoute } from 'common/const/route.enum';
import { UserHooks } from 'common/hooks';

interface IComponentProps {
  title: string;
}

export const InventoryEmptyList: FC<IComponentProps> = ({ title }) => {
  const navigate = useNavigate();
  const { isAccountAdmin } = UserHooks.useCurrentUserRole();

  return (
    <EmptyState
      title={title}
      description={
        isAccountAdmin
          ? 'Найдите и закажите необходимое оборудование в каталоге товаров'
          : 'Найдите всё, что вам необходимо, в каталоге и закажите на ваше рабочее место'
      }
      btnTitle="В каталог"
      onClick={() => navigate(ERoute.Catalog)}
    />
  );
};
